export default __webpack_public_path__ + "static/media/Kothian Battle Gauntlets.21687a0e.jpg";